import { useState } from 'react';

import {
    Box, Collapse, IconButton, Paper, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, Typography
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import DashboardCard from '../components/DashboardCard';

const currency = new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN'
});

const TopProductRow = ({ product }) => {
    const [open, setOpen] = useState(false);

    return <>
        <TableRow hover>
            <TableCell padding="checkbox">
                <IconButton aria-label={`Ver variantes de ${product.title}`} size="small"
                    onClick={() => setOpen(current => !current)}>
                    {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                </IconButton>
            </TableCell>
            <TableCell>{product.rank}</TableCell>
            <TableCell>{product.title}</TableCell>
            <TableCell align="right">{product.units}</TableCell>
            <TableCell align="right">{product.order_count}</TableCell>
            <TableCell align="right">{currency.format(product.sales_total)}</TableCell>
        </TableRow>
        <TableRow>
            <TableCell colSpan={6} sx={{ py: 0 }}>
                <Collapse in={open} timeout="auto" unmountOnExit>
                    <Box sx={{ m: 1.5 }}>
                        <Typography gutterBottom variant="subtitle2">Variantes vendidas</Typography>
                        <Table size="small">
                            <TableHead><TableRow>
                                <TableCell>Variante</TableCell>
                                <TableCell align="right">Unidades</TableCell>
                                <TableCell align="right">Venta acumulada</TableCell>
                            </TableRow></TableHead>
                            <TableBody>{product.variants.map(variant => <TableRow
                                key={variant.variant_id || variant.title}>
                                <TableCell>{variant.title}</TableCell>
                                <TableCell align="right">{variant.units}</TableCell>
                                <TableCell align="right">{currency.format(variant.sales_total)}</TableCell>
                            </TableRow>)}</TableBody>
                        </Table>
                    </Box>
                </Collapse>
            </TableCell>
        </TableRow>
    </>;
};

const TopProductsHistory = ({ products, loading }) => <DashboardCard
    title="Top 10 histórico de productos vendidos"
>
    {loading ? <Typography color="text.secondary">Calculando ventas históricas…</Typography>
        : products === null ? <Typography color="error">
            No se pudo recuperar el Top 10 histórico.
        </Typography> : products.length === 0 ? <Typography color="text.secondary">
            No hay pedidos aprobados y entregados para mostrar.
        </Typography> : <TableContainer component={Paper} variant="outlined">
            <Table size="small" sx={{ minWidth: 720 }}>
                <TableHead><TableRow>
                    <TableCell padding="checkbox" />
                    <TableCell>Posición</TableCell>
                    <TableCell>Producto</TableCell>
                    <TableCell align="right">Unidades vendidas</TableCell>
                    <TableCell align="right">Pedidos</TableCell>
                    <TableCell align="right">Venta acumulada</TableCell>
                </TableRow></TableHead>
                <TableBody>{products.map(product => <TopProductRow
                    key={product.product_id}
                    product={product}
                />)}</TableBody>
            </Table>
        </TableContainer>}
</DashboardCard>;

export default TopProductsHistory;
